<template>
    <div class="app-container">
        <!-- <div class="detailsTitle">
            <h4>磅差范围</h4>
        </div> -->
        <div style="padding: 20px 0 0 0;">
            <el-form :model="searchFrom" :rules="rules" ref="searchFrom" inline label-width="120px">
                <el-form-item label="主副磅差范围:" prop="poundDifference" class="jiage">
                    <el-input placeholder="请输入" maxlength="5" :disabled="flag" size="mini"
                        v-model="searchFrom.poundDifference"    @input="inputChange" v-number-input.float="1"></el-input>
                    <span class="danwei">%</span>
                    <span>&nbsp;以内</span>
                </el-form-item>
                <div class="panel">
                    <!-- <el-button type="primary" @click="handleSubmit">保 存</el-button> -->
                    <el-button type="primary" @click="successFn(1)" btnCode="01K0090100" v-if="btnFlg[0] && !flag">保
                        存</el-button>
                    <el-button type="primary" @click="successFn(2)" btnCode="01K0090200" v-if="btnFlg[1] && flag">编
                        辑</el-button>
                    <el-button type="primary" @click="searchFn" :disabled="flag">取 消</el-button>

                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import { editPoundDifference, getPoundDifference } from '@/api/lj'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'

export default {
  data () {
    return {
      searchFrom: { poundDifference: '' },
      flag: false,
      rules: {
        poundDifference: [
          { required: true, message: '请输入主副磅差范围', trigger: ['blur', 'change'] },
          { pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/, message: '请输入正确的格式,可保留1位小数' }
          // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确的格式,可保留1位小数' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['01K0090100', '01K0090200', '01K0070300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/differenceRange')
    this.getList()
  },
  mounted () { },
  methods: {
    // change(){ this.$forceUpdate();},
    // 查选
    inputChange () {
      if (this.searchFrom.poundDifference > 100) {
        this.$set(this.searchFrom, 'poundDifference', 100)
      }
      // if (this.searchFrom.poundDifference == 0) {
      // this.$set(this.searchFrom, 'poundDifference',0.1)

      // }
    },
    searchFn () {
      this.getList(this.searchFrom)
    },

    getList () {
      getPoundDifference(this.searchFrom)
        .then((res) => {
          this.searchFrom = {}
          if (res == null) {
            this.flag = false
            this.$refs.searchFrom.clearValidate()
          } else {
            this.flag = true

            let obj = { ...res }
            this.$set(this.searchFrom, 'poundDifference', obj.itemNo)
            this.$set(this.searchFrom, 'id', obj.id)
          }
        })
        .catch((error) => {
          this.$message({
            message: error.message,
            type: 'error',
            onClose () { }
          })
        })
    },
    successFn (val) {
      this.$refs.searchFrom.validate((valid) => {
        if (valid) {
          // 保存
          if (val == 1) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            editPoundDifference(this.searchFrom).then(res => {
              DonMessage.success('保存成功')
              loading.close()
              this.searchFrom = {}
              this.getList()
            }).catch(err => {
              loading.close()

              DonMessage.error(err.message)
            })
          } else {
            // 修改
            this.flag = false
          }
        }
        // this.getList()
      })
    }
  }
}
</script>
<style scoped lang="less">
.el-form {
    width: 400px;
    margin-left: 10px;

    .el-form-item {
        margin-bottom: 20px;

        .el-input {
            width: 200px;
        }
    }

    .panel {
        margin-left: 10px
    }
}

/deep/.jiage .el-form-item__content {
    position: relative;

    .danwei {
        position: absolute;
        // right: -20px;
        padding: 1px 29px;
    }
}

/deep/.el-input.is-disabled .el-input__inner {

    color: #000000;
}
</style>
